<template>
  <RollBlock>
    <template v-slot:content>
      <div
        ref="description"
        class="detail-text"
        v-html="getSelectedProduct.text"
      ></div>

      <!-- <div class="grid-row grid-row_md d-flex_wrap mt-8">
        <div
          v-for="(item, key) in getDocuments"
          :key="key"
          class="grid-col grid-col_50 grid-col_xl-100 grid-col_lg-50 grid-col_sm-100 pt-16 pt-sm-8"
        >
          <DocLink :text="item.name" :link="item.path" />
        </div>
      </div> -->
    </template>

    <template v-slot:text-button> Развернуть описание </template>
    <template v-slot:text-button-active> Свернуть описание </template>
  </RollBlock>
</template>

<script>
import RollBlock from "../RollBlock/RollBlock.vue";
// import DocLink from "../DocLink/DocLink.vue";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
import { Fancybox } from "@fancyapps/ui";

export default {
  name: "DescriptionBlock",
  components: {
    RollBlock,
    // DocLink,
  },
  mounted() {
    Fancybox.bind(this.$refs.description, "img", {
      ...(this.options || {}),
    });
  },
  computed: {
    ...mapState(useProductStore, ["getDocuments", "getSelectedProduct"]),
  },
};
</script>

<style lang="scss">
@import "./description.scss";
</style>
